<template>
  <DeleteProductModal />
  <CreateProductModal />
  <UpdateProductModal />
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">
    <div
      class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7"
    >
      <div class="d-flex align-items-center">
        <a
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 text-decoration-none"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#CreateProductModal"
        >
          <span class="d-none d-md-inline">Criar produto</span>
          <i class="flaticon-plus position-relative fs-12 product-create-icon"></i>
        </a>
      </div>
      <div class="d-flex align-items-center w-100 ms-lg-auto" style="max-width: 350px; position: relative; z-index: 99;">
        <multiselect
          ref="productSelect"
          v-model="selectedSearchProduct"
          :options="getProductsSearchList"
          :searchable="true"
          :loading="isLoadingProducts"
          :internal-search="false"
          :custom-label="formatProductOption"
          :taggable="false"
          label="name"
          track-by="id"
          no-options-text="Nenhum produto encontrado."
          no-result-text="Nenhum resultado para sua busca."
          placeholder="Buscar produto..."
          @search-change="debouncedFetchProducts"
          @select="onProductSelect"
          :close-on-select="true"
          id="product_search"
          class="w-100"
        >
          <template #noOptions>
            <div>Comece a digitar para buscar produtos.</div>
          </template>
          <template #noResult>
            Nenhum produto encontrado
          </template>
        </multiselect>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25 mt-10">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Nome
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                SKU
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Descrição
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Preço
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Editar
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Deletar
              </th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="(value, key) in getProductCatalogList" :key="value.id || key">
              
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ value.name != '' && value.name != null  ? value.name : 'Sem nome' }}
                  </div>
                </div>
              </th>
              
              <td class="shadow-none lh-1 fw-medium">
                <span class="product-table__sku" :title="value.sku || ''">
                  {{ formatSku(value.sku) }}
                </span>
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span class="product-table__description" :title="value.description || ''">
                  {{ formatDescription(value.description) }}
                </span>
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.price != '' && value.price != null  ? 'R$ ' + parseFloat(value.price).toFixed(2).replace('.', ',') : '-' }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button v-on:click="setCurrentUpdateProduct(value)" data-bs-toggle="modal" data-bs-target="#UpdateProductModal" class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button">
                  <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                </button>
              </td>

              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button v-on:click="setCurrentDeleteProduct(value)" data-bs-toggle="modal" data-bs-target="#DeleteProductModal" class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button">
                  <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                </button>
              </td>

            </tr>
          
          </tbody>
        </table>
      </div>

      <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20">
        <div class="fs-14 text-muted mb-10 mb-sm-0">
          Página {{ currentPage }} de {{ getProductCatalogPagination.last_page || 1 }} —
          Total de {{ getProductCatalogPagination.total || getProductCatalogList.length }} produtos
        </div>
        <nav aria-label="Paginação de produtos">
          <ul class="pagination mb-0">
            <li class="page-item" :class="{ disabled: currentPage <= 1 }">
              <button type="button" class="page-link" @click="goToPage(currentPage - 1)" :disabled="currentPage <= 1">
                Anterior
              </button>
            </li>
            <li class="page-item" :class="{ disabled: currentPage >= getProductCatalogPagination.last_page }">
              <button type="button" class="page-link" @click="goToPage(currentPage + 1)" :disabled="currentPage >= getProductCatalogPagination.last_page">
                Próxima
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import DeleteProductModal from './DeleteProductModal.vue';
import CreateProductModal from './CreateProductModal.vue';
import UpdateProductModal from './UpdateProductModal.vue';

export default defineComponent({
  name: "ProductsList",
  data() {
    return {
      currentPage: 1,
      selectedSearchProduct: null,
      isLoadingProducts: false,
      lastProductQuery: '',
      productFetchTimer: undefined as number | undefined,
      pendingProductQuery: ''
    };
  },
  computed: {
    ...mapGetters([
      'getProductCatalogList',
      'getProductsSearchList',
      'getProductCatalogPagination'
    ])
  },
  components: {
    DeleteProductModal,
    CreateProductModal,
    UpdateProductModal,
    Multiselect
  },
  methods: {
    ...mapActions([
      "setCurrentDeleteProduct",
      "setCurrentUpdateProduct",
      "setProductCatalogList",
      "setProductsSearchList"
    ]),
    formatProductOption(product: { name?: string; sku?: string; price?: string | number }) {
      const price = product.price ? ` - R$ ${parseFloat(String(product.price)).toFixed(2).replace('.', ',')}` : '';
      const sku = product.sku ? ` - ${product.sku}` : '';
      return `${product.name || 'Sem nome'}${price}${sku}`;
    },
    formatSku(sku?: string | null) {
      if (!sku) return '-';

      return sku.length > 15 ? `${sku.slice(0, 15)}...` : sku;
    },
    formatDescription(description?: string | null) {
      if (!description) return '-';

      return description.length > 15 ? `${description.slice(0, 15)}...` : description;
    },
    async fetchProducts(query) {
      if (!query || query.length < 2 || query === this.lastProductQuery) return;

      this.lastProductQuery = query;
      this.isLoadingProducts = true;

      try {
        await this.setProductsSearchList(query);
      } catch (error) {
        this.setProductsSearchList('');
      } finally {
        this.isLoadingProducts = false;
      }
    },
    debouncedFetchProducts(query: string) {
      this.pendingProductQuery = query;

      if (this.productFetchTimer) {
        clearTimeout(this.productFetchTimer);
      }

      this.productFetchTimer = window.setTimeout(() => {
        this.fetchProducts(this.pendingProductQuery);
        this.productFetchTimer = undefined;
      }, 600);
    },
    onProductSelect(product: unknown) {
      this.setCurrentUpdateProduct(product);

      this.$nextTick(() => {
        const modalEl = document.getElementById('UpdateProductModal');
        if (!modalEl) return;

        if (window.bootstrap && window.bootstrap.Modal) {
          try {
            const modalInstance = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
            modalInstance.show();
          } catch(e) {
            this.openUpdateModalWithFallback();
          }
        } else {
          this.openUpdateModalWithFallback();
        }

        this.selectedSearchProduct = null;
      });
    },
    openUpdateModalWithFallback() {
      const btn = document.createElement('button');
      btn.setAttribute('data-bs-toggle', 'modal');
      btn.setAttribute('data-bs-target', '#UpdateProductModal');
      document.body.appendChild(btn);
      btn.click();
      document.body.removeChild(btn);
    },
    async loadPage(page) {
      if (!page || page < 1) {
        page = 1;
      }

      this.currentPage = page;
      await this.setProductCatalogList(page);
    },
    goToPage(page) {
      if (page < 1 || (this.getProductCatalogPagination.last_page && page > this.getProductCatalogPagination.last_page)) {
        return;
      }

      this.loadPage(page);
    }
  },
  mounted() {
    this.loadPage(1);
  },
  watch: {
    getProductCatalogPagination: {
      immediate: true,
      handler(newVal) {
        this.currentPage = newVal && newVal.current_page ? newVal.current_page : 1;
      }
    }
  }
});
</script>

<style scoped>
.product-create-icon {
  margin-left: 0;
}

.product-table__sku,
.product-table__description {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
}

.product-table__sku {
  max-width: 150px;
}

.product-table__description {
  max-width: 360px;
}

@media (min-width: 768px) {
  .product-create-icon {
    margin-left: 5px;
  }
}

@media (max-width: 767.98px) {
  .product-table__description {
    max-width: 220px;
  }
}
</style>
